// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"b766094e","25":"7a7ec023","43":"32981342","48":"282f5938","384":"aeedf5c0","485":"282d01b4"}[chunkId] + ".chunk.css";
};